/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import VasTagCla from '../VasTagCla/VasTagCla';
import { getVasConfigValues } from 'Selectors/config';
import { FormattedMessage as Translation } from 'react-intl';

import { setVasItem } from 'Actions/vasSheet';
import css from './VasTags.APP_TARGET.scss';
import { BLACKBACKGROUND2, MONETIZATIONDARK1 } from 'Constants/colors';

export const VasTagsCla = ({ itemId, vasConfigValues, setVasItem, gradient, onVasTagTap, onTrack }) => {
    const maxItemCard = 4;
    const itemForMap = vasConfigValues.length > maxItemCard ? vasConfigValues.slice(0, maxItemCard) : vasConfigValues;

    return (
        <>
            {
                itemForMap?.length > 0 && (
                    <>
                        <div className={ css.wrapper } data-aut-id="vas-tags-banner">
                            <h3 className={ css.titleText }><Translation id="includePrice" /></h3>
                            {
                                itemForMap.map(vasConfigVal => (
                                    <VasTagCla
                                        key={ vasConfigVal.title }
                                        vasConfigVal={ vasConfigVal }
                                        itemId={ itemId }
                                        setVasItem={ setVasItem }
                                        gradient={ gradient }
                                        onVasTagTap={ onVasTagTap }
                                        onTrack={ onTrack }
                                    />
                                ))
                            }
                        </div>
                    </>)
            }
        </>
    );
};
const mapStateToProps = (state, ownProps) => ({
    vasConfigValues: getVasConfigValues(state, ownProps.vasValues || [])
});

export const mapDispatchToProps = dispatch => ({
    setVasItem: state => dispatch(setVasItem(state))
});

VasTagsCla.propTypes = {
    itemId: PropTypes.string.isRequired,
    vasConfigValues: PropTypes.array.isRequired,
    setVasItem: PropTypes.func.isRequired,
    gradient: PropTypes.oneOf([BLACKBACKGROUND2, MONETIZATIONDARK1]),
    onVasTagTap: PropTypes.func.isRequired,
    onTrack: PropTypes.func.isRequired
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    React.memo
)(VasTagsCla);
